<script lang="ts">
  interface SortValue {
    value: string;
    displayName: string;
    displayShortName: string;
    isDefault: boolean;
  }

  interface Props {
    /*                                          */
    ruleString: string;
    /*                                                     */
    selectedSortKey: string;
    /*                                                       */
    valuesJson: string;
  }

  const { ruleString, selectedSortKey, valuesJson }: Props = $props();

  const values: SortValue[] = $derived(JSON.parse(valuesJson ?? "[]"));
</script>

<form
  id="find_filter_sorting"
  class="find_filter ts_sortingForm"
  action="/grasshopper/filter/resolve"
  autocomplete="off"
  method="post"
  novalidate
>
  <input type="hidden" name="rule" value={ruleString} />
  <input type="hidden" name="l" value="" />
  <fieldset class="heureka_sorting__relevantValues"></fieldset>
  <ul class="find_inlineSorting heureka_overflowBox heureka_overflowBox--loading ts_heureka_overflowBox">
    {#each values as value (value.value)}
      <li
        class={`heureka_overflowBox__item ${value.value === selectedSortKey ? "heureka_overflowBox__item--first" : ""} find_filter_sorting--chip`}
      >
        <oc-chip-v2
          class="hc_facetValueInput"
          selection="single"
          name="sortiertnach"
          value={value.value}
          oc-aria-label={value.value}
          as-button=""
          {...value.value === selectedSortKey ? { checked: "" } : {}}
        >
          <span>{value.displayShortName}</span>
        </oc-chip-v2>
      </li>
    {/each}
  </ul>
</form>
